if (typeof Symbol === 'undefined') {
    Object.defineProperty(window, 'Symbol', { value: { iterator: 'Symbol.iterator' }, configurable: true });
}
import { Events, Mixable as Class } from './object-plus/index.js';
import { Record as Model } from './record/index.js';
export * from './collection/index.js';
export * from './io-tools.js';
export * from './object-plus/index.js';
export * from './record/index.js';
export * from './relations/index.js';
export * from './transactions.js';
export { Model, Class };
export const { on, off, trigger, once, listenTo, stopListening, listenToOnce } = Events;
export function transaction(method) {
    return function (...args) {
        let result;
        this.transaction(() => {
            result = method.apply(this, args);
        });
        return result;
    };
}
//# sourceMappingURL=index.js.map